import React from 'react';
import { UserRole } from '../../containers/OrdersPage/types';

let chat24Loaded = false;

// монтирование чата
export function Chat2Desk(
  dataUser: any,
  path: string,
  setChatInitialized: React.Dispatch<React.SetStateAction<boolean>>
) {
  if (dataUser.role !== UserRole.PHARMACIST) return;
  if (chat24Loaded) return;

  // добавление стилей - сокрытие иконки и позиционирование чата
  function injectChatStyles() {
    const styleContent = `
    .online-chat.online-chat--light.online-chat--vertical.online-chat--right {
      position: fixed;
      top: 160px !important;
      right: 70px !important;
      max-height: 100px !important;
    }

    @media (max-width: 768px) {
      .online-chat.online-chat--light.online-chat--vertical.online-chat--right {
        top: 48px !important;
        right: 8px !important;
      }
    }

    .widget.widget--collapsed {
      display: none !important; /* скрываем сам блок мессенджеров */
    }

    .startBtn.startBtn--collapsed {
      display: none !important;
    }
  `;

    const host = document.querySelector(
      '#chat24-root chat-24'
    ) as HTMLElement | null;
    const targetRoot = (host && (host as any).shadowRoot) as ShadowRoot | null;

    const exists =
      (targetRoot
        ? targetRoot.querySelector('#chat24-position-patch')
        : document.head?.querySelector('#chat24-position-patch')) ||
      document.querySelector('#chat24-position-patch');

    if (exists) return;

    const styleEl = document.createElement('style');
    styleEl.id = 'chat24-position-patch';
    styleEl.textContent = styleContent;

    if (targetRoot) {
      targetRoot.appendChild(styleEl);
    } else if (document.head) {
      document.head.appendChild(styleEl);
    } else {
      document.appendChild(styleEl);
    }
  }

  function waitAndInjectStyles() {
    injectChatStyles();

    const obs = new MutationObserver(() => {
      injectChatStyles();
      const host = document.querySelector('#chat24-root chat-24') as any;
      if (host?.shadowRoot) {
        obs.disconnect();
      }
    });

    obs.observe(document.body, { childList: true, subtree: true });
  }

  function applyClientInfo(dataUser: any) {
    const chat24: any = document.querySelector('#chat24-root chat-24');
    if (chat24 && typeof chat24.sendClientInfo === 'function') {
      const defs = chat24.getCustomFields() ?? [];

      const byName: Record<string, number> = {};
      defs.forEach((f: any) => {
        byName[f.name] = f.id;
      });

      const phone = String(dataUser.phone || '').replace(/^(\+?7|8)/, '+7');
      const lastOrder = path.split('/')[2]
        ? {
            [byName.last_order]: path.split('/')[2],
          }
        : {};

      chat24.sendClientInfo({
        name: `ФЦ: ${dataUser.networkName} ${dataUser.networkCode}`,
        phone: 'Номер фармацевта ниже',
        customFields: {
          [byName.current_pharmacist]: phone,
          [byName.current_page]: path,
          ...lastOrder,
        },
      });

      return true;
    }
    return false;
  }

  const start = () => {
    if (chat24Loaded) {
      applyClientInfo(dataUser);
      return;
    }

    // слушатель на ппервое сообщение
    document.addEventListener('first_client_message', () => {
      applyClientInfo(dataUser);
    });

    // инициализируем чат
    (window as any).chat24_token = process.env.REACT_APP_CHAT2DESK_API_TOKEN;
    (window as any).chat24_url = 'https://livechat-02.chat2desk.kz';
    (window as any).chat24_socket_url =
      'wss://livechat-02.chat2desk.kz/widget_ws_new';
    (window as any).chat24_static_files_domain =
      'https://storage-02.chat2desk.kz//';
    (window as any).lang = 'ru';

    fetch(
      `${(window as any).chat24_url}/packs/manifest.json?nocache=${Date.now()}`
    )
      .then((res) => res.json())
      .then((data) => {
        const s = document.createElement('script');
        s.async = true;
        s.src = `${(window as any).chat24_url}${data['application.js']}`;
        s.onload = () => {
          chat24Loaded = true;
          waitAndInjectStyles();
        };
        document.body.appendChild(s);
        setChatInitialized(true);
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}
